import ajv from "@f/validation/ajv";
import {FollowTheForest, FollowTheForestSchema} from "@f/validation/schema/followTheForest";

export const validateFollowTheForest = ajv.compile<FollowTheForest>(FollowTheForestSchema)
